<div class="search-field">
  <label *ngIf="label" class="search-label">{{ label }}</label>
  <p-iconField iconPosition="left">
    <p-inputIcon styleClass="fas fa-search"></p-inputIcon>
    <input
      #searchWord
      appDebounceInput
      [value]="searchValue"
      (debounceInput)="onSearch(searchWord.value)"
      [debounceMs]="1000"
      [class]="inputStyleClass"
      [disabled]="disabled"
      [ngClass]="{ 'pr-6': showClearButton }"
      [placeholder]="placeholder"
      pInputText
      type="text" />
    <p-inputIcon
      *ngIf="showClearButton && searchWord.value.length"
      (click)="clearInput()"
      styleClass="fas fa-times right-0 left-auto mr-3 cursor-pointer"></p-inputIcon>
  </p-iconField>
</div>
